import { iconColors } from '../../config/icons';

export default {
  name: 'gcAccountIcon',
  props: {
    color: {
      type: String,
      default() {
        return iconColors.dark;
      },
    },
  },
};
